import { antiguedadEnMinutos, describirAntiguedad, sugerirVentana } from '../ventanas';

/**
 * Estado vacío que se explica.
 *
 * «Sin datos» es correcto y a la vez inútil: se lee como «esto no funciona».
 * Las tres razones de una pantalla vacía piden respuestas distintas —el tenant
 * nunca envió nada, envió pero fuera de la ventana, o dejó de enviar hace
 * mucho— y solo una de ellas la puede resolver el usuario con un clic.
 */
export function SinDatos({
  ultimo,
  ventanaActual,
  onAmpliar,
}: {
  /** Marca del último dato del tenant, o null si nunca recibió nada. */
  ultimo: string | null;
  ventanaActual: number;
  onAmpliar: (minutos: number) => void;
}) {
  if (!ultimo) {
    return (
      <div className="sin-datos">
        <p>Este tenant todavía no ha enviado telemetría.</p>
        <p className="tenue">
          Revisa que el SDK esté inicializado y apuntando al endpoint de ingesta correcto.
        </p>
      </div>
    );
  }

  const antiguedad = antiguedadEnMinutos(ultimo);
  const sugerencia = sugerirVentana(ultimo, ventanaActual);

  if (!sugerencia) {
    return (
      <div className="sin-datos">
        <p>Sin ejecuciones en esta ventana.</p>
        <p className="tenue">El último dato es de {describirAntiguedad(antiguedad)}.</p>
      </div>
    );
  }

  return (
    <div className="sin-datos">
      <p>Sin ejecuciones en esta ventana.</p>
      <p className="tenue">Pero hay datos: el último llegó {describirAntiguedad(antiguedad)}.</p>
      <button onClick={() => onAmpliar(sugerencia.minutos)}>
        Ver {sugerencia.etiqueta.toLowerCase()}
      </button>
    </div>
  );
}
